import React, { useState, useEffect } from "react";
import '../../css/CssDoctorRegistration.css';
import favDocLogo from '../../assets/favdoctor logo 1.png';
import backGround from '../../assets/login-bg.png';
import m_background from '../../assets/mbil-service.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import check from '../../assets/ckeck.png'
import crumb from '../../assets/crumbs2.png';
import Logo from '../../components/logo/Logo'
import LoginHeader from '../../components/Header/LoginHeader'
import '../land/land.css';
import { useNavigate, Link } from "react-router-dom";
import { useStateValue } from "../../stateprovider";
import instance from '../../axios';
import { format } from 'date-fns';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import TextField from '@material-ui/core/TextField';


function UserRegistrationStep2() {
    const navigate = useNavigate();
    const [{ user }, dispatch] = useStateValue();
    const [selectedPicture, setselectedPicture] = useState(null);
    const [maritalStatus, setmaritalStatus] = useState("");
    const [gender, setGender] = useState("");
    const [dob, setDOB] = useState("");
    const [country, setCountry] = useState("");
    const [theState, setTheState] = useState("");
    const [selected, setSelected] = useState(new Date());

    let footer = <p>Please pick a day.</p>;
    if (selected) {
        footer = <p>You picked {format(selected, 'PP')}.</p>;
    }

    useEffect(() => {
        if (user === null) {
            navigate('/')
        }
    }, [user])
    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append("selectPicture", selectedPicture);
        //    await instance.post('/uploadImage', formData)
        //    fetch('http://127.0.0.1:5001/favouritedoctor-7a5fa/us-central1/api/uploadImage', {
        //     method: 'POST',
        //     headers: {"content-type": "multipart/form-data"},
        //     body: formData,
        //   }).then((response) => {
        //     if (response.ok) {
        //       return response.json(); // Parse response data if needed
        //     }
        //     throw new Error('Upload failed');
        //   })
        //   .then((data) => {
        //     console.log(data); // Handle successful response
        //   })
        //   .catch((error) => {
        //     console.error(error); // Handle error
        //   });
        dispatch({
            type: "CREATE_USER",
            user: {
                user: user, picture: selectedPicture, maritalStatus: maritalStatus,
                gender: gender, dob: dob, theState: theState, country: country
            }
        });
        navigate('/User_SignUp_Step3');
    }
    let date = new Date();
    let year = date.getFullYear();
    return (

        <div className="DocRegMain" >

            <div className="DocRegMain__BackgroundImage">
                <img src={backGround} alt="BackgroundImage" />
                <img src={m_background} alt="BackgroundImage" />

            </div>
            <div className="DocRegMain__Header">

                {/* <article className='favdoc__land-nav' style={{ zIndex: 20 }}>
                        <Logo />
                        <div className='favdoc__land-nav_login'>
                           
                        </div>
    </article>*/}
                <LoginHeader />
            </div>
            <div className="UserRegMain__SignUpSection">
                <div className="UserRegMain__SignUpForm">
                    <form onSubmit={handleSubmit} encType="multipart/form-data">
                        <img src={crumb} alt="Crumbs" style={{ marginBottom: 25 + 'px' }} />

                        {/*   <div className="photo">

                         <div className='profile-input' style={{paddingTop: 57 + 'px'}}>
                            <FontAwesomeIcon icon='camera' className="camera camera-color" />
                            <input type="file" accept="image/x-png,image/gif,image/jpeg" onChange={(e) => setselectedPicture(URL.createObjectURL(e.target.files[0]))} className="file" name="photo" />

                        </div>
    </div>*/}
                        <div className='profile-picture photo' style={{ marginBottom: 5 + 'px' }}>
                            <img src={(selectedPicture === "" || selectedPicture === null) ? selectedPicture : URL.createObjectURL(selectedPicture)} className="profile" alt=" " style={(selectedPicture === "") ? { visibility: 'hidden' } : { visibility: 'visible' }} />
                            <div className='profile-input'>

                                <FontAwesomeIcon icon='camera' className="camera camera-color" />
                                <input type="file" accept="image/x-png,image/gif,image/jpeg"
                                    onChange={(e) => setselectedPicture(e.target.files[0])}
                                    className="file" name="selectPicture" required />

                            </div>
                        </div>
                        <span style={{ color: "#84d1e4", fontSize: 12 + "px", fontWeight: 400, }}>{selectedPicture?.name}</span>
                        <div className="container" style={{ marginTop: 10 + 'px' }}>
                            <div className="row" style={{ marginBottom: 20 + 'px', justifyContent: 'space-between' }}>
                                <div className="col-12">
                                    <div className={(theState.length > 3) ? "complete active input-check" : "disabled input-check"} style={{ margin: 0 }}>
                                        <select name="residence" value={theState} placeholder="State of Residence"

                                            onChange={(e) => setTheState(e.target.value)} required>
                                            <option value="" aria-disabled="true">State of Residence</option>
                                            <option value="Abia ">Abia </option>
                                            <option value="Adamawa ">Adamawa </option>
                                            <option value="Akwa Ibom">Akwa Ibom</option>
                                            <option value="Anambra">Anambra</option>
                                            <option value="Bauchi">Bauchi</option>
                                            <option value="Bayelsa">Bayelsa</option>
                                            <option value="Benue">Benue</option>
                                            <option value="Borno">Borno</option>
                                            <option value="Cross River">Cross River</option>
                                            <option value="Delta">Delta</option>
                                            <option value="Ebonyi">Ebonyi</option>
                                            <option value="Edo">Edo</option>
                                            <option value="Ekiti">Ekiti</option>
                                            <option value="Enugu">Enugu</option>
                                            <option value="Gombe">Gombe</option>
                                            <option value="Imo">Imo</option>
                                            <option value="Jigawa">Jigawa</option>
                                            <option value="Kaduna">Kaduna</option>
                                            <option value="Kano">Kano</option>
                                            <option value="Katsina">Katsina</option>
                                            <option value="Kebbi">Kebbi</option>
                                            <option value="Kogi">Kogi</option>
                                            <option value="Kwara">Kwara</option>
                                            <option value="Lagos">Lagos</option>
                                            <option value="Nasarawa">Nasarawa</option>
                                            <option value="Niger">Niger</option>
                                            <option value="Ogun">Ogun</option>
                                            <option value="Ondo">Ondo</option>
                                            <option value="Osun">Osun</option>
                                            <option value="Oyo">Oyo</option>
                                            <option value="Plateau">Plateau</option>
                                            <option value="Rivers">Rivers</option>
                                            <option value="Sokoto">Sokoto</option>
                                            <option value="Taraba">Taraba</option>
                                            <option value="Yobe">Yobe</option>
                                            <option value="Zamfara">Zamfara</option>

                                        </select>
                                        <img src={check} alt="" className={(theState.length > 3) ? "display" : "check"} style={{ width: "fit-content" }} />
                                    </div>
                                </div>
                                {/*  <div className="col-6">
                                            <div  className={(country.length > 3) ? "complete active input-check" : "disabled input-check"} style={{ margin: 0 }}>
                                                <select name="State of Origin" value={country} placeholder="State of Origin"
                                                    disabled={theState.length < 3} onChange={(e) => setCountry(e.target.value)} required>
                                                    <option value="" aria-disabled="true" selected>State of Origin</option>
                                                    <option value="Abia ">Abia </option>
                                                    <option value="Adamawa ">Adamawa </option>
                                                    <option value="Akwa Ibom">Akwa Ibom</option>
                                                    <option value="Anambra">Anambra</option>
                                                    <option value="Bauchi">Bauchi</option>
                                                    <option value="Bayelsa">Bayelsa</option>
                                                    <option value="Benue">Benue</option>
                                                    <option value="Borno">Borno</option>
                                                    <option value="Cross River">Cross River</option>
                                                    <option value="Delta">Delta</option>
                                                    <option value="Ebonyi">Ebonyi</option>
                                                    <option value="Edo">Edo</option>
                                                    <option value="Ekiti">Ekiti</option>
                                                    <option value="Enugu">Enugu</option>
                                                    <option value="Gombe">Gombe</option>
                                                    <option value="Imo">Imo</option>
                                                    <option value="Jigawa">Jigawa</option>
                                                    <option value="Kaduna">Kaduna</option>
                                                    <option value="Kano">Kano</option>
                                                    <option value="Katsina">Katsina</option>
                                                    <option value="Kebbi">Kebbi</option>
                                                    <option value="Kogi">Kogi</option>
                                                    <option value="Kwara">Kwara</option>
                                                    <option value="Lagos">Lagos</option>
                                                    <option value="Nasarawa">Nasarawa</option>
                                                    <option value="Niger">Niger</option>
                                                    <option value="Ogun">Ogun</option>
                                                    <option value="Ondo">Ondo</option>
                                                    <option value="Osun">Osun</option>
                                                    <option value="Oyo">Oyo</option>
                                                    <option value="Plateau">Plateau</option>
                                                    <option value="Rivers">Rivers</option>
                                                    <option value="Sokoto">Sokoto</option>
                                                    <option value="Taraba">Taraba</option>
                                                    <option value="Yobe">Yobe</option>
                                                    <option value="Zamfara">Zamfara</option>

                                                </select>
                                                    <img src={check} alt="" className={(country.length > 3) ? "display" : "check"} />

                                            </div>
</div>*/}
                            </div>
                            <div className="row" style={{ justifyContent: 'space-between' }}>
                                <div className="col-4">
                                    <div className={dob ? "complete active input-check" : "disabled input-check"} style={{ margin: 0, paddingLeft: 10 + "px" }}>

                                        {/*    <input type="date" value={dob}  placeholder="Date of Birth" name="DOB"
                                                    required />
*/}
                                        <TextField
                                            id="date"
                                            label="DOB"
                                            type="date"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            onChange={(e) => setDOB(e.target.value)}
                                            disabled={(theState.length < 3)} 
                                            required
                                        />
                                        <img src={check} alt="" className={(dob.length > 3) ? "display" : "check"} style={{width: "fit-content", top: 8 + "px"}}/>
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className={(gender) ? "complete active input-check" : "disabled input-check"} style={{ margin: 0 }}>
                                        <select name="Sex" value={gender}
                                            disabled={!dob} onChange={(e) => setGender(e.target.value)} required>
                                            <option value="" aria-disabled="true">Sex</option>

                                            <option value="Male">Male</option>
                                            <option value="female">Female</option>

                                        </select>

                                        <img src={check} alt="" className={(gender.length > 3) ? "display" : "check"} style={{ width: "fit-content" }} />

                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className={maritalStatus ? "complete input-check active" : " active disabled input-check"}
                                        style={{ margin: 0 }}>

                                        <select name="marital" value={maritalStatus} onChange={(e) => setmaritalStatus(e.target.value)}
                                            disabled={!gender} required>
                                            <option value="" aria-disabled="true">Marital Status</option>
                                            <option value="Single">Single</option>
                                            <option value="Married">Married</option>
                                            <option value="Divorced">Divorced</option>
                                            <option value="Widowed">Widowed</option>
                                        </select>

                                        <img src={check} alt="" className={(maritalStatus.length > 3) ? "display" : "check"} style={{ width: "fit-content" }} />
                                    </div>
                                </div>
                            </div>
                            <button className={!maritalStatus ? "disabled_button" : "button disabled_button"} disabled={!maritalStatus}>Continue</button>
                            <p style={{
                                marginBottom: 0, color: "#0F0F0F",
                                fontWeight: 300, fontStyle: 'italic'
                            }}>Already have an account?<Link to="/login">
                                    <span style={{ color: "#01B6E2", fontStyle: "normal", cursor: "pointer", textDecoration: "none", paddingLeft: 5 + 'px' }}>
                                        <b>Login</b></span></Link> </p>
                        </div>




                    </form>

                </div>
            </div>

            <div className="DocRegMain__Footer">
                <div className="DocRegMain__Brand">
                    <p>&copy; {year} FavDoctor</p>
                </div>
            </div>

        </div>

    )
}

export default UserRegistrationStep2;